






























































import { DataProxy } from 'apollo-cache';
import gql from 'graphql-tag';
import * as R from 'ramda';
import Vue from 'vue';

import { Client, Project } from '@/core/entity';

import ProjectForm from './Form.vue';
import { getClientQL, listProjectQL, projectFragment } from './graphql';

export default Vue.extend({
  components: {
    'form-project': ProjectForm,
  },

  apollo: {
    client: {
      query: getClientQL,
      variables() {
        return { id: this.clientId };
      },
      fetchPolicy: 'cache-first',
    },
    projects: {
      query: listProjectQL,
      variables() {
        return { clientId: this.clientId };
      },
      fetchPolicy: 'cache-first',
    },
  },

  data() {
    const projectId =
      this.$route.name === 'client.project.new'
        ? 'new'
        : this.$route.params.project_id;
    return {
      client: null as Client | null,
      isDrawerVisible: projectId ? true : false,
      projects: [] as Project[],
      loading: false,
    };
  },

  computed: {
    cardTitle(): string {
      return this.client ? `${this.client.name}'s Project List` : '';
    },

    clientId(): string {
      return this.$route.params.client_id;
    },

    drawerTitle(): string {
      return this.isNewProject() ? 'Create a new project' : 'Edit project';
    },

    projectId(): string {
      return this.$route.name === 'client.project.new'
        ? 'new'
        : this.$route.params.project_id;
    },
  },

  watch: {
    projectId(newVal: string | null) {
      this.isDrawerVisible = !!newVal;
    },
  },

  methods: {
    isNewProject(): boolean {
      return this.projectId === 'new';
    },
    handleSave(val: any) {
      const { clientId, projectId } = this;

      if (projectId && projectId !== 'new') {
        // update project
        this.$coreApp.project.update(
          projectId,
          {
            client: clientId,
            name: val.name,
            note: val.note,
          },
          this.presenter('Project updated.', 'Unable to update project:'),
          { name: 'ListProjectPageProject', query: projectFragment },
          this.updater,
        );
      } else {
        // create project
        this.$coreApp.project.create(
          {
            client: clientId,
            name: val.name,
            note: val.note,
            outlets: val.outlets,
          },
          val.file,
          this.presenter('Project created.', 'Unable to create project:'),
          { name: 'ListProjectPageProject', query: projectFragment },
          this.updater,
        );
      }
    },

    hideDrawer() {
      this.isDrawerVisible = false;
      if (this.projectId) {
        this.$router.back();
      }
    },

    presenter(success: string, failure: string) {
      return (err: Error | null, result: Project | null, loading: boolean) => {
        this.loading = loading;
        if (err) {
          this.$message.error(`${failure} ${err.message}`);
        } else if (result !== null) {
          this.$message.success(success);

          if (!this.projectId) {
            this.isDrawerVisible = false;
          } else {
            this.$router.back();
          }
        }
      };
    },

    updater(
      store: DataProxy,
      res: {
        data: {
          newProject?: Project;
          updateProject?: Project;
        };
      },
    ) {
      const project = (res.data.newProject ||
        res.data.updateProject) as Project;

      const data: { projects: Project[] } | null = store.readQuery({
        query: listProjectQL,
        variables: { clientId: this.clientId },
      });

      if (res.data.newProject) {
        // created
        data!.projects = R.prepend(project, data!.projects);
      } else if (res.data.updateProject) {
        // updated
        const idx = R.findIndex(R.propEq('id', project.id))(data!.projects);
        if (idx === -1) {
          // tslint:disable-next-line no-console
          console.error('Unable to find project in projects');
          return;
        }

        const previous = data!.projects[idx];
        data!.projects = R.update(
          idx,
          {
            ...previous,
            ...project,
          },
          data!.projects,
        );
      }

      store.writeQuery({
        query: listProjectQL,
        variables: { clientId: this.clientId },
        data,
      });
    },
  },
});
